import { render, staticRenderFns } from "./TexturePanel.vue?vue&type=template&id=365c4700&scoped=true"
import script from "./TexturePanel.vue?vue&type=script&lang=js"
export * from "./TexturePanel.vue?vue&type=script&lang=js"
import style0 from "./TexturePanel.vue?vue&type=style&index=0&id=365c4700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c4700",
  null
  
)

export default component.exports